const Events = 
{
    EstimatedPolygonCreated: "EstimatedPolygonCreated",
    EnableDrawMode: "EnableDrawMode",
    GetModifiedShape: "GetModifiedShape",
    DisableDrawMode: "DisableDrawMode",
    CompleteDrawMode: "CompleteDrawMode",
    UploadGeometry: "UploadGeometry",
    ModifiedShapeUploaded: "ModifiedShapeUploaded",
    ModifiedGraphicChanged: "ModifiedGraphicChanged",
    ClearModifiedLayer: "ClearModifiedLayer",
    ActualsPolygonCreated: "ActualsPolygonCreated",
    ActualsLineCreated: "ActualsLineCreated",
    ActualsPointCreated: "ActualsPointCreated",
    RefreshLayer: "RefreshLayer",
    ClearGraphicsEvent: "ClearGraphicsEvent",
    ZoomTo: "ZoomTo",
    EnablePointMode: "EnablePointMode",
    EstimatedPointCreated: "EstimatedPointCreated",
    ToggleIsMovingPoint: "ToggleIsMovingPoint",
    GetIsMovingPoint: "GetIsMovingPoint",
    ToggleShouldUpdateGraphic: "ToggleShouldUpdateGraphic",
    GetShouldUpdateGraphic: "GetShouldUpdateGraphic",
    CopyPolygon: "CopyPolygon",
    GetWFFTSAttributes: "GetWFFTSAttributes",
    SetWFFTSAttributes: "SetWFFTSAttributes",
    GetLegacyAttributes: "GetLegacyAttributes",
    SetLegacyAttributes: "SetLegacyAttributes",
    SetActualIsNew: "SetActualIsNew",
    GetActualIsNew: "GetActualIsNew",
    CopyFromNewActualTreatmentPolygon: "CopyFromNewActualTreatmentPolygon",
    CopyFromNewActualActivityPolygon: "CopyFromNewActualActivityPolygon",
    CopyFromNewLegacyActualTreatmentPolygon: "CopyFromNewLegacyActualTreatmentPolygon",
    CopyFromNewLegacyActualActivityPolygon: "CopyFromNewLegacyActualActivityPolygon",
    SetActualIsTreatment: "SetActualIsTreatment",
    GetActualIsTreatment: "GetActualIsTreatment",
    SetPlannedFeatureAttributes: "SetPlannedFeatureAttributes",
    GetPlannedFeatureAttributes: "GetPlannedFeatureAttributes",
    DisableExistingIcons: "DisableExistingIcons",
    DisableNewEstimatedIcons: "DisableNewEstimatedIcons",
    DisableNewActualIcons: "DisableNewActualIcons",
    EstimatedLineCreated: "EstimatedLineCreated",
    EnablePostFirePointMode: "EnablePostFirePointMode",
    EnablePostFireLineMode: "EnablePostFireLineMode",
    SetExistingGeo: "SetExistingGeo",
    ResetMapView: "ResetMapView",
    TriggerFieldChange: "TriggerFieldChange",
    TriggerInteragencyFieldChange: "TriggerInteragencyFieldChange",
    UpdateRequiredFields: "UpdateRequiredFields",
    ModifiedGraphicChangedAttr: "ModifiedGraphicChangedAttr",
    ModifiedGraphicPostFirePointChanged: "ModifiedGraphicPostFirePointChanged",
    CopyFromExistingPolygon: "CopyFromExistingPolygon",
    WfftsShapeCreated: "WfftsShapeCreated",
    ModifiedGraphicLineChanged: "ModifiedGraphicLineChanged",
    CreateProject: "CreateProject",
    ExistingProject: "ExistingProject",
    DisableProjectCreate: "DisableProjectCreate",
    LockProgramOfWork: "LockProgramOfWork",
    ClearSketchGraphicsLayer: "ClearSketchGraphicsLayer",
    HighlightExistingFeature: "HighlightExistingFeature",
    RemoveExistingFeatureHighlight: "RemoveExistingFeatureHighlight",
};

export default Events;
